import { signal } from '@preact/signals'

/**
 * «Звук сигнала» из профиля (макет `ProfileMobile`).
 *
 * Уведомление показывает служебный сценарий, а он не видит хранилища страницы —
 * поэтому признак дублируется в кэш браузера: страница пишет, сценарий читает.
 * Выключенный звук — это `silent: true` у уведомления: платформа гасит и звук,
 * и вибрацию, отдельной ручки только для звука в вебе нет.
 */

const KEY = 'moonwake.sound'
export const CACHE = 'moonwake-prefs'
export const SOUND_URL = '/prefs/sound'

export const soundOn = signal(true)

export function loadSound(): void {
  try {
    soundOn.value = globalThis.localStorage?.getItem(KEY) !== 'off'
  } catch {
    soundOn.value = true
  }
  void mirror(soundOn.value)
}

export async function setSound(on: boolean): Promise<void> {
  soundOn.value = on
  try {
    globalThis.localStorage?.setItem(KEY, on ? 'on' : 'off')
  } catch {
    // приватный режим — останется только на время сеанса
  }
  await mirror(on)
}

/** Кладёт признак туда, куда дотянется служебный сценарий. */
async function mirror(on: boolean): Promise<void> {
  try {
    const cache = await globalThis.caches?.open(CACHE)
    await cache?.put(SOUND_URL, new Response(on ? 'on' : 'off'))
  } catch {
    // без кэша уведомления просто останутся со звуком
  }
}
